import { render, staticRenderFns } from "./RelatedRPDocsSectionEditor.vue?vue&type=template&id=2f50f28e"
import script from "./RelatedRPDocsSectionEditor.vue?vue&type=script&lang=ts"
export * from "./RelatedRPDocsSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./RelatedRPDocsSectionEditor.vue?vue&type=style&index=0&id=2f50f28e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports